import {
	Component,
	ChangeDetectionStrategy,
	Input,
	Output,
	EventEmitter,
	OnInit,
	OnDestroy,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { distinctUntilChanged, debounceTime, takeUntil } from 'rxjs/operators';
import { MatIcon } from '@angular/material/icon';

//TODO Rename to au-native-search-input
@Component({
	selector: 'au-native-input',
	templateUrl: './au-native-input.component.html',
	styleUrls: ['./au-native-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatIcon, ReactiveFormsModule],
})
export class AuNativeInputComponent implements OnInit, OnDestroy {
	private destroy$: Subject<void> = new Subject<void>();

	@Input() placeholder: string = '';
	@Input() set value(value) {
		this.controlValue = value;
		if (this.control) {
			this.control.setValue(value);
		}
	}

	@Output() inputChanged = new EventEmitter<string>();
	@Output() clear = new EventEmitter<void>();
	@Output() controlReady = new EventEmitter<FormControl<string>>();
	@Output() inputKeyDown = new EventEmitter<KeyboardEvent>();
	@Output() inputOnFocus = new EventEmitter<boolean>();

	control: FormControl;
	private controlValue: any;

	constructor() {}

	ngOnInit() {
		this.createControlAndSubscribe();
		this.controlReady.emit(this.control);
	}

	createControlAndSubscribe() {
		this.control = new FormControl(this.controlValue);
		this.control.valueChanges
			.pipe(distinctUntilChanged(), debounceTime(300), takeUntil(this.destroy$))
			.subscribe(value => {
				this.inputChanged.emit(value);
			});
	}

	clearHandler() {
		this.control.setValue('');
		this.clear.emit();
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}

	inputFocusIn() {
		this.inputOnFocus.emit(true);
	}

	inputFocusOut() {
		this.inputOnFocus.emit(false);
	}
}
